"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "transactions/5.0.1";
